import { Injectable } from '@angular/core';
import { Quark, Url, JSONData, HttpResponse, HttpGet } from 'sol-request-angular/dist/comunicacao';
import { environment } from '../../environments/environment';
import { LoaderService } from 'app/services/loader.service';
import { Usuario } from '@tivic-team/manager-ts/dist/seg';

@Injectable()
export class LoginController {

    constructor(private _loaderService:LoaderService) { }

    async getTemporaryAccessToken(): Promise<Usuario> {

        this._loaderService.show();

        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'login/access-token',
                    environment: environment
                }),
            }),
            new HttpResponse({})
        );
        
        return await quark.call().finally(() => {
            this._loaderService.hide();
        });
    }
}
